export { default, getServerSideProps } from 'components/landing/mcp/StoreAnalyticsMcpPage'
